// Promos que siembra el sistema (hoy solo el bono de bienvenida): solo se pausan, reanudan y se
// les cambian el monto del bono y el centro de costo con que se imputa.
import { z } from 'zod';
import type { SalePromotion, UpdateSalePromotionRequest } from '../api/promotionsContract';
import {
    COST_CENTER_MESSAGES,
    costCenterError,
    costCenterForUpdate,
    costCenterText,
} from '@/shared/lib/costCenter/costCenter';
import { FORM_MESSAGES, fromHundredths, isMoney, toCents } from './salePromotionForm';

export const SYSTEM_PROMOTION_BADGE = 'Sistema';
export const SYSTEM_PROMOTION_BADGE_TITLE =
    'Bono de bienvenida: lo crea el sistema. Solo se pausa, se reanuda o se cambian el monto y el centro de costo.';

/** Tercer renglón de la lista: no tiene alcance ni vigencia que describir. */
export const SYSTEM_PROMOTION_SCOPE = 'Al abrir cuenta · Permanente';

export function isSystemPromotion(promo: Pick<SalePromotion, 'systemKey'>): boolean {
    return promo.systemKey !== undefined;
}

export const welcomeBonusFormSchema = z.object({
    amount: z.string().refine(isMoney, FORM_MESSAGES.money),
    costCenterId: z.string().refine((text) => !costCenterError(text), COST_CENTER_MESSAGES.tooLong),
});

export type WelcomeBonusFormValues = z.infer<typeof welcomeBonusFormSchema>;

export function welcomeBonusFormValues(promo: SalePromotion): WelcomeBonusFormValues {
    const cents = promo.levers.walletBonus?.amountCents;
    return {
        amount: cents === undefined ? '' : fromHundredths(cents),
        costCenterId: costCenterText(promo.costCenterId),
    };
}

/** El único parche que acepta el back para una promo de sistema: el monto y el centro de costo. */
export function toWelcomeBonusUpdateRequest(
    values: WelcomeBonusFormValues,
): UpdateSalePromotionRequest {
    return {
        levers: { walletBonus: { amountCents: toCents(values.amount) } },
        costCenterId: costCenterForUpdate(values.costCenterId),
    };
}
